/**
 * @generated SignedSource<<d7616828e8787de1e8b54bd16113fd7d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedEstimatedValue_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pricingGuidanceHelpers_item" | "useGetEstimatedValueRange_item" | "useShowPricingGuidance_item">;
  readonly " $fragmentType": "PdpSharedEstimatedValue_item";
};
export type PdpSharedEstimatedValue_item$key = {
  readonly " $data"?: PdpSharedEstimatedValue_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedEstimatedValue_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedEstimatedValue_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPricingGuidance_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetEstimatedValueRange_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pricingGuidanceHelpers_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "1d92693f8e39b2663650981994bd344e";

export default node;
